import HeroSection from './components/HeroSection';
import FeaturedContent from './components/FeaturedContent';
import CategoryShowcase from './components/CategoryShowcase';
import CreatorEcosystem from './components/CreatorEcosystem';
import StatsSection from './components/StatsSection';
import TestimonialsSection from './components/TestimonialsSection';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <FeaturedContent />
      <CategoryShowcase />
      <CreatorEcosystem />
      <StatsSection />
      <TestimonialsSection />
    </main>
  );
}